
const EditIcon = () => {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PP---Desktop---Chat-Thread---Charts-and-Graphs---1920-Copy" transform="translate(-1709, -61)" stroke="#000" strokeWidth="2">
                    <g id="Group-4-Copy-3" transform="translate(1710.1896, 55)">
                        <g id="Group-9" transform="translate(0, 7.1162)">
                            <polygon id="Stroke-1" points="4.337 12.046 0 13.25 1.326 9.035 10.362 0 13.373 3.011"></polygon>
                            <line x1="2.0514" y1="8.3096" x2="5.0624" y2="11.3206" id="Stroke-3"></line>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default EditIcon;
